<template>
  <div class="more-categories" v-bind:class="{'wide-view': wideView}" v-if="categories.length">
    <ul>
      <!-- D-233 (A8b): hrefless `<a @click.prevent>` — mouse-only. They FILTER the list,
           they do not navigate, so a `<button>` is the honest element: converting a real
           navigation would have cost middle-click and open-in-new-tab, and there is no
           navigation here to lose. `.prevent` goes with the `<a>` that needed it.
           🔑 WCAG 2.5.8's 24px floor still does not apply, and that is not an oversight:
           its Inline exception covers a target whose size is constrained by the
           line-height of surrounding text, which is what these are before and after the
           conversion. R11's comment already recorded the exemption for that reason. -->
      <li><button type="button" v-on:click="onClick(null)">All</button></li>
      <li v-for="category in categories" :key="category.id">
        <button type="button" v-on:click="onClick(category)">{{category.name}}</button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ['categories', 'containerWidth'],
  computed: {
    wideView() {
      return this.containerWidth >= 590;
    },
  },
  methods: {
    onClick(category) {
      this.$parent.switchCategory(category);
    },
  },
};
</script>

<style lang="less" scoped>
  .more-categories {
    border-top: #dddddd 1px solid;
    ul {
      font-size: 0;
      list-style: none;
      margin: 0 0 24px 0;
      padding: 0;

      li {
        display: inline;
        font-size: 12px;
        line-height: 24px;
        cursor: pointer;
        margin-left: 12px;

        &:before {
          content: "";
          display: inline-block;
          margin-right: 3px;
          background-image: url(../assets/tag.svg);
          background-size: cover;
          height: 12px;
          width: 12px;
        }

        // D-233 (A8b): was `a`. The UA chrome comes off here so the conversion moves no
        // pixel — `font: inherit` is the load-bearing one, since a button does not
        // inherit the page font and these are sized by the text around them.
        button {
          color: grey;
          cursor: pointer;
          background: transparent;
          border: 0;
          padding: 0;
          margin: 0;
          font: inherit;
          // 🔑 `line-height: normal` fixes a real box, and — recorded honestly, because
          // the first version of this comment claimed otherwise — it is NOT what kept the
          // goldens still. The 15 v1 cells that moved were the pagination reset
          // (see `pagination.vue`); this box difference paints nothing, because the box is
          // transparent and only the glyphs render. It is fixed anyway: a control 10px
          // taller than its own `<li>`, overhanging 5px at each edge, is a wrong HIT AREA
          // even when it is an invisible one.
          //
          // MEASURED in a real chromium, probing the live boxes:
          //     <a>      x=27 y=270 w=15.34 h=14
          //     <button> x=27 y=270 w=15.34 h=24   <- before this line
          //
          // An inline non-replaced element's box is its font CONTENT AREA (14px for this
          // 12px text). An inline-BLOCK's box is its LINE BOX, and `.more-categories li`
          // sets `line-height: 24px` for the spacing between wrapped rows — so the button
          // inherited 24px and grew 10px, overflowing its own `<li>` by 5px at each edge.
          //
          // 🪤 `display: inline` DOES NOT FIX IT, which is why it is not what is here.
          // Blink blockifies `<button>` and ignores `display: inline` on it, so the
          // declaration reads as correct, passes review, and changes nothing. The sibling
          // conversion in `podcast.vue` was pixel-clean by luck for exactly this reason:
          // `ul.categories li` sets no line-height, so `normal` was already in effect.
          //
          // The `<li>`'s own 24px line-height is untouched, so row spacing is unchanged.
          // `normal` lands at 15px against the anchor's 14px content area — 1px, which no
          // golden can see and which `display: inline` would have fixed if Blink honoured
          // it. Left at `normal` rather than hard-coding 14px, because a magic number
          // tuned to one font at one size is the more fragile of the two.
          line-height: normal;

          &:hover {
            opacity: .6;
          }
        }
      }
    }
  }
  .more-categories.wide-view {
    ul {
      li { width: 33.3%; }
    }
  }

  .dark-theme .more-categories ul li button {
    color: lightgrey;
  }
</style>
